/**
 * index.js
 *
 * @Author: zhangce
 * @Date: 17/8/23 上午11:38
 */

import Tag from './Tag';
import CheckableTag from './CheckableTag';
import TagGroup from './TagGroup';

Tag.CheckableTag = CheckableTag;
export { CheckableTag, TagGroup };
export default Tag;



// WEBPACK FOOTER //
// ./src/tag/index.js